/**
 * Menu laterale aperto o ridotto a icone, e chi se lo ricorda.
 *
 * <p>Ogni vista avvolge se stessa in {@code <Layout>}: a ogni cambio pagina il layout viene
 * smontato e rimontato da capo, e al rimontaggio il watcher con {@code immediate} di
 * right-bar.vue riscrive {@code data-sidebar-size} con il valore del negozio. Una scelta che
 * viva soltanto sull'attributo del DOM — come faceva l'hamburger — alla pagina dopo e' gia'
 * persa, e si vede il menu che si riapre da solo.
 *
 * <p>Va applicata PRIMA che Vue disegni, come il tema: altrimenti il primo fotogramma ha il
 * menu aperto e quello dopo lo chiude, ed e' proprio il rimbalzo da evitare.
 *
 * <p>Sta nel browser e non nelle preferenze dell'utenza, per la stessa ragione del tema: e'
 * una scelta del dispositivo. Sul monitor grande il menu aperto ci sta, sul portatile stretto
 * si preferisce ridotto, ed e' la stessa persona.
 */
const CHIAVE = "zoelia_menu_laterale";

/**
 * Le uniche due che ha senso ricordare.
 *
 * <p>Sotto i 768px il menu e' un pannello che si sovrappone e si chiude da solo: ricordarlo
 * vorrebbe dire riaprirlo addosso a chi cambia pagina. Le altre misure di Velzon ('md',
 * 'sm-hover') qui non si usano.
 */
const AMMESSE = ["lg", "sm"];

/** Com'era l'ultima volta, o aperto se non lo sappiamo. */
export function dimensioneIniziale() {
  try {
    const salvata = localStorage.getItem(CHIAVE);
    return AMMESSE.includes(salvata) ? salvata : "lg";
  } catch (e) {
    // Navigazione privata o archiviazione negata: si parte aperto, senza rompere nulla.
    return "lg";
  }
}

/** Da chiamare quando la scelta la fa l'utente, non quando la impone la larghezza. */
export function ricorda(dimensione) {
  if (!AMMESSE.includes(dimensione)) return;
  try {
    localStorage.setItem(CHIAVE, dimensione);
  } catch (e) {
    // Se non si puo' scrivere vale per questa sessione soltanto: meglio di un errore.
  }
}

/** Sull'elemento {@code <html>}, dove il CSS di Velzon va a cercarla. */
export function applica(dimensione) {
  document.documentElement.setAttribute("data-sidebar-size", dimensione);
}
